import type {
  AcceptOddsPreferences,
  DefaultHubPreferences,
  OddsFormatPreferences,
} from "@/hooks/firestore/v2/user/usePreferences";
import type { Nullable } from "types/utilities";
import { message } from "utilities/message/message";
import { err, ok } from "utilities/result";

const updateBettingPreferences = async ({
  acceptOdds = null,
  oddsFormat = null,
  defaultHub = null,
  allowCancelWithdrawal = null,
}: Partial<{
  acceptOdds: Nullable<AcceptOddsPreferences>;
  oddsFormat: Nullable<OddsFormatPreferences>;
  defaultHub: Nullable<DefaultHubPreferences>;
  allowCancelWithdrawal: Nullable<boolean>;
}>) => {
  const [response, error] = await message("update-user-settings", {
    acceptOdds,
    oddsFormat,
    defaultHub,
    allowCancelWithdrawal,
  });

  if (error) {
    return err(error);
  }

  return ok(response);
};

export const bettingPreferencesService = {
  updateBettingPreferences,
};
